import {Country} from './country.model';

export class CountryConfig {

  countries: Array<Country>;

}
